import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../store';
import { dispatchCusEvent } from '../../utils';
import { ENUM_CUS_EVENT } from '../../enums/enums';

export default function useGetFsCampaign(groupId) {
  const campaigns = useAppSelector((state) => state.freeSpin.campaignByGroupId)?.[groupId] || [];
  const [alreadyRequest, setAlreadyRequest] = useState(false);

  useEffect(() => {
    if (!groupId) return;
    if (alreadyRequest) return;
    if (campaigns?.length) return;
    dispatchCusEvent(ENUM_CUS_EVENT.getFreespinList, { groupId });
    setAlreadyRequest(true);
  }, [campaigns, groupId]);

  return campaigns;
}
